module.exports = __webpack_public_path__ + "img/hhc_eisai2.3e2aafaa.png";